import { render, staticRenderFns } from "./choiceText.vue?vue&type=template&id=598ab9b5&scoped=true&"
import script from "./choiceText.vue?vue&type=script&lang=ts&"
export * from "./choiceText.vue?vue&type=script&lang=ts&"
import style0 from "./choiceText.vue?vue&type=style&index=0&id=598ab9b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598ab9b5",
  null
  
)

export default component.exports